module.exports = __webpack_public_path__ + "static/media/0072443-educatormisconductposter_landscape_2-1.e963ed68.pdf";